import React from 'react';
import VisuallyHidden from '@atlaskit/visually-hidden';
import Content from '../shared/content';
import IconRenderer from '../shared/icon-renderer';
import renderLoadingOverlay from '../shared/loading-overlay';
import useButtonBase from '../shared/use-button-base';
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */
var useIconButton = function useIconButton(_ref) {
  var analyticsContext = _ref.analyticsContext,
    appearance = _ref.appearance,
    ariaLabel = _ref.ariaLabel,
    ariaLabelledBy = _ref.ariaLabelledBy,
    autoFocus = _ref.autoFocus,
    buttonType = _ref.buttonType,
    icon = _ref.icon,
    interactionName = _ref.interactionName,
    isDisabled = _ref.isDisabled,
    isLoading = _ref.isLoading,
    isSelected = _ref.isSelected,
    label = _ref.label,
    onClick = _ref.onClick,
    onClickCapture = _ref.onClickCapture,
    onKeyDownCapture = _ref.onKeyDownCapture,
    onKeyUpCapture = _ref.onKeyUpCapture,
    onMouseDownCapture = _ref.onMouseDownCapture,
    onMouseUpCapture = _ref.onMouseUpCapture,
    onPointerDownCapture = _ref.onPointerDownCapture,
    onPointerUpCapture = _ref.onPointerUpCapture,
    onTouchEndCapture = _ref.onTouchEndCapture,
    onTouchStartCapture = _ref.onTouchStartCapture,
    overlay = _ref.overlay,
    ref = _ref.ref,
    shape = _ref.shape,
    shouldFitContainer = _ref.shouldFitContainer,
    spacing = _ref.spacing,
    testId = _ref.testId,
    UNSAFE_size = _ref.UNSAFE_size;
  var hasOverlay = Boolean(overlay || isLoading);
  var isCircle = shape === 'circle';
  var baseProps = useButtonBase({
    analyticsContext: analyticsContext,
    appearance: appearance,
    autoFocus: autoFocus,
    ariaLabel: ariaLabel,
    ariaLabelledBy: ariaLabelledBy,
    buttonType: buttonType,
    children: /*#__PURE__*/React.createElement(Content, {
      type: "icon",
      hasOverlay: hasOverlay
    }, /*#__PURE__*/React.createElement(IconRenderer, {
      icon: icon,
      size: UNSAFE_size
    }), /*#__PURE__*/React.createElement(VisuallyHidden, null, label)),
    interactionName: interactionName,
    isDisabled: isDisabled,
    isLoading: isLoading,
    isSelected: isSelected,
    isIconButton: true,
    isCircle: isCircle,
    onClick: onClick,
    onMouseDownCapture: onMouseDownCapture,
    onMouseUpCapture: onMouseUpCapture,
    onKeyDownCapture: onKeyDownCapture,
    onKeyUpCapture: onKeyUpCapture,
    onTouchStartCapture: onTouchStartCapture,
    onTouchEndCapture: onTouchEndCapture,
    onPointerDownCapture: onPointerDownCapture,
    onPointerUpCapture: onPointerUpCapture,
    onClickCapture: onClickCapture,
    overlay: isLoading ? renderLoadingOverlay({
      spacing: spacing,
      appearance: appearance,
      isDisabled: isDisabled,
      isSelected: isSelected,
      testId: testId
    }) : overlay,
    ref: ref,
    shouldFitContainer: shouldFitContainer,
    spacing: spacing
  });
  return baseProps;
};
export default useIconButton;